import { Box, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export const FooterInfo = ({ children }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: 1,
        bgcolor: "rgba(25, 118, 210, 0.2)",
        borderRadius: 2,
        padding: "10px 5px",
      }}
    >
      <InfoOutlinedIcon
        sx={{
          fontSize: 18,
          color: "rgba(25, 118, 210)",
          position: "relative",
          top: "2px",
        }}
      />

      <Typography variant="body2" color="rgba(35, 118, 210)">
        {children}
      </Typography>
    </Box>
  );
};
